import React from "react";
import styles from "./ErrorMessage.module.scss";
import Alert from "../Alert/Alert";
import { InfoIcon } from "../../icons/InfoIcon";

const ErrorMessage = ({ errors, errorMessages, name, label, minLength }) => {
  const error = errors[name];

  if (!error) return null;

  const defaultErrorMessages = {
    required: {
      title: (
        <>
          <span className={styles.titleIcon}>
            <InfoIcon />
          </span>{" "}
          Missing Info
        </>
      ),
      text: `${label.replace(":", "")} is required.`,
    },
    pattern: {
      text: `Please enter a valid ${label.toLowerCase()}.`,
    },
    minLength: {
      text: `${label} must be ${minLength} characters`,
    },
    maxLength: {
      text: "You have exceeded the number of characters for this field.",
    },
  };

  const customErrorMessages = {
    ...defaultErrorMessages,
    ...errorMessages,
  };

  const customError =
    error.type === "required"
      ? { ...defaultErrorMessages["required"], ...customErrorMessages["required"] }
      : error.type === "minLength"
      ? customErrorMessages["minLength"]
      : error.type === "pattern"
      ? customErrorMessages["pattern"]
      : customErrorMessages[error.message] || customErrorMessages[error.type];

  const { title, text, center = true } = customError ? customError : { text: error.message };

  return (
    <Alert
      className={styles.errorMessage}
      titleClassName={`d-flex align-items-center${center ? " justify-content-center" : ""}`}
      title={title}
      text={text}
      type="Warning"
      center={center}
    />
  );
};

export default ErrorMessage;
